<template>
  <section class="section">
    <h3 class="title is-4 is-spaced">
      <span>{{ $t('orderDetails.title', { orderNumber: order.id }) }}</span>
    </h3>
    <div class="columns is-centered">
      <div class="column">
        <h4 class="title is-5 is-spaced">
          <span>{{ $t('orderDetails.text.orderDetails') }}</span>
        </h4>
        <div class="field">
          <label class="label">{{ $t('orderDetails.fields.date') }}</label>
          <span>{{ formattedOrder.createdAt }}</span>
        </div>
        <div class="field">
          <label class="label">{{ $t('orderDetails.fields.status') }}</label>
          <span><status-tag :status="order.status.status.toLowerCase()"></status-tag></span>
        </div>
        <div class="field">
          <label class="label">{{ $t('orderDetails.fields.expiration') }}</label>
          <span>{{ formattedOrder.expiresAt }}</span>
        </div>
        <div class="field">
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>{{ $t('orderDetails.fields.product') }}</th>
                <th>{{ $t('orderDetails.fields.quantity') }}</th>
                <th>{{ $t('orderDetails.fields.price') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr :key="product.id" v-for="product in order.lineItems">
                <td>{{ product.price_data.product_data.name }}</td>
                <td>{{ product.quantity }}</td>
                <td>{{ product.price_data.unit_amount }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="field">
          <label class="label">{{ $t('orderDetails.fields.totalProducts') }}</label>
          <span>{{ order.subTotal }} {{ order.currency }}</span>
        </div>
        <div class="field">
          <label class="label">{{ $t('orderDetails.fields.tax') }}</label>
          <span>{{ order.tax }} {{ order.currency }}</span>
        </div>
        <div class="field">
          <label class="label">{{ $t('orderDetails.fields.shippingCosts') }}</label>
          <span>{{ order.shippingCost }} {{ order.currency }}</span>
        </div>
        <div class="field">
          <label class="label">{{ $t('orderDetails.fields.totalPaid') }}</label>
          <span>{{ order.total }} {{ order.currency }}</span>
        </div>
      </div>
      <div class="column">
        <h4 class="title is-5 is-spaced">
          <span>{{ $t('orderDetails.text.customerDetails') }}</span>
        </h4>

        <form-section label="Shipping">
          <ul>
            <li>{{ order.shippingName }}</li>
            <li>{{ order.shippingLine1 }}</li>
            <li>{{ order.shippingPostalCode }} {{ order.shippingCity }}</li>
            <li>{{ order.shippingCountry }}</li>
            <li>{{ order.shippingCity }}</li>
          </ul>
        </form-section>

        <form-section label="Invoice" class="mt-5">
          <ul>
            <li>{{ order.customerName }}</li>
            <li>{{ order.customerLine1 }}</li>
            <li>{{ order.customerPostalCode }} {{ order.customerCity }}</li>
            <li>{{ order.customerCountry }}</li>
            <li>{{ $t('orderDetails.fields.email') }} {{ order.customerEmail }}</li>
          </ul>
        </form-section>

        <article class="message is-dark">
          <div class="message-body">
            <form-section label="Notes from the customer">
              {{ order.messageFromBuyer }}
            </form-section>
          </div>
        </article>
      </div>
    </div>
    <!-- <div class="columns is-centered" v-if="order.status == 'New'">
      <div class="column is-one-third">
        <h4 class="title is-4 is-spaced">
          <span>{{ $t('orderDetails.text.acceptOrderUntil', new { deadline: order.deadline}) }}</span>
        </h4>
        <nav class="level is-mobile">
          <div class="level-item has-text-centered">
            <primary-button label="Accept" class="is-fullwidth" @click="setStatus('processing')"></primary-button>
          </div>
          <div class="level-item has-text-centered">
            <primary-button label="Decline" class="is-fullwidth" @click="setStatus('declined')"></primary-button>
          </div>
          <div class="level-item has-text-centered">
            <primary-button label="Proposal" class="is-fullwidth" @click="setStatus('proposal')"></primary-button>
          </div>
        </nav>
      </div>
    </div> -->

    <!-- PENDING -->
    <div class="columns" v-if="order.status.status == 'pending'">
      <div class="column is-half message is-dark">
        <h4 class="title is-4 is-spaced">
          <span>{{ $t('orderDetails.text.newOrder') }}</span>
        </h4>
        <primary-button label="Accept" class="" @click="acceptOrder()"></primary-button>
        <primary-button label="Decline" class="" @click="declineOrder()"></primary-button>
      </div>
    </div>
    <!-- / PENDING -->

    <!-- ACCEPTED -->
    <div class="columns" v-if="order.status.status == 'accepted'">
      <div class="column is-half message is-dark">
        <h4 class="title is-4 is-spaced">
          <span>{{ $t('orderDetails.text.shippingDetailsUntil', { deadline: order.expiresAt }) }}</span>
        </h4>
        <div class="field">
          <label class="label">{{ $t('orderDetails.fields.shippingCompany') }}</label>
          <p class="control has-icons-left has-icons-right">
            <input class="input" type="text" placeholder="" v-model="shippingTrackingCompany"
              v-bind:class="{
                  'is-danger': errors && !shippingTrackingCompany
                }" />
            <span class="icon is-small is-left">
              <i class="fa fa-building"></i>
            </span>
          </p>
        </div>
        <div class="field">
          <label class="label">{{ $t('orderDetails.fields.trackingCode') }}</label>
          <p class="control has-icons-left has-icons-right">
            <input class="input" type="text" placeholder="" v-model="shippingTrackingCode"
              v-bind:class="{
                  'is-danger': errors && !shippingTrackingCode
                }" />
            <span class="icon is-small is-left">
              <i class="fa fa-truck"></i>
            </span>
          </p>
        </div>
        <div class="field is-grouped">
          <div class="control">
            <primary-button label="Submit" class="is-fullwidth" @click="addTracking()"></primary-button>
          </div>
        </div>
      </div>
    </div>
    <!-- / ACCEPTED -->

    <!-- DECLINED -->
    <div class="columns" v-if="order.status.status == 'declined'">
      <div class="column is-half message is-dark">
        <h4 class="title is-4 is-spaced">
          <span>{{ $t('orderDetails.text.productDeclined') }}</span>
        </h4>
        <!-- <div class="field">
          <label class="label">Selected reason:</label>
          <span>Products not available.</span>
        </div> -->
      </div>
    </div>
    <!-- / DECLINED -->

    <!-- SHIPPING EXPIRED -->
    <div class="columns" v-if="order.status.status == 'shipping-expired'">
      <div class="column is-half message is-dark">
        <h4 class="title is-4 is-spaced">
          <span>{{ $t('orderDetails.text.productShippingExpired') }}</span>
        </h4>
      </div>
    </div>
    <!-- / SHIPPING EXPIRED -->

    <!-- ACCEPTANCE EXPIRED -->
    <div class="columns" v-if="order.status.status == 'acceptance-expired'">
      <div class="column is-half message is-dark">
        <h4 class="title is-4 is-spaced">
          <span>{{ $t('orderDetails.text.productAcceptanceExpired') }}</span>
        </h4>
      </div>
    </div>
    <!-- / ACCEPTANCE EXPIRED -->

    <!-- FULFILLED -->
    <div class="columns" v-if="order.status.status == 'fulfilled'">
      <div class="column is-half message is-dark">
        <h4 class="title is-4 is-spaced">
          <span>{{ $t('orderDetails.text.productFullfiled') }}</span>
        </h4>
      </div>
    </div>
    <!-- / FULFILLED -->

    <!-- PROPOSAL -->
    <div class="columns" v-if="order.status.status == 'proposal'">
      <div class="column is-one-third">
        <h4 class="title is-4 is-spaced">
          <span>{{ $t('orderDetails.text.productSubstitution') }}</span>
        </h4>
        <article class="message is-dark">
          <div class="message-body">
            <form-section label="You" class="has-text-left">
              The product "Item 1" is not available anymore. I propose to send yuo one extra "Item 4" instead? Let me know if you like the idea.
            </form-section>
          </div>
        </article>

        <article class="message is-dark">
          <div class="message-body">
            <form-section label="You" class="has-text-right">
              Ok. Thanks. Is it possible to have an additional "Item 2" instead of "Item 4"?
            </form-section>
          </div>
        </article>

        <div class="field">
          <label class="label">You</label>
          <div class="control">
            <textarea class="textarea" placeholder="Textarea"></textarea>
          </div>
        </div>

        <div class="field is-grouped">
          <div class="control">
            <primary-button label="Send" class="is-fullwidth" @click="sendProposal()"></primary-button>
          </div>
        </div>
      </div>
    </div>
    <!-- /PROPOSAL -->
  </section>
</template>

<script>
import FormSection from '@/components/forms/FormSection'
import PrimaryButton from '@/components/forms/PrimaryButton'
import StatusTag from '@/components/forms/StatusTag.vue'
import { Helpers } from '@/services/helpers.service'
import { FooshiApi } from '@/services/fooshiApi.service'

export default {
  name: 'OrderDetails',
  components: {
    FormSection,
    PrimaryButton,
    StatusTag
  },
  methods: {
    async fetchOrder () {
      var response = await FooshiApi.getOrder(this.$route.params.id)
      if (response.success) {
        this.order = response.data
      }
    },
    // async fetchStatus () {
    //   var response = await FooshiApi.getOrderStatus(this.$route.params.id)
    //   if (response.success) {
    //     this.status = response.data
    //   }
    // },
    async acceptOrder () {
      var response = await FooshiApi.acceptOrder(this.$route.params.id)
      if (response.success) {
        await this.fetchOrder()
      }
    },
    async declineOrder () {
      var response = await FooshiApi.declineOrder(this.$route.params.id)
      if (response.success) {
        await this.fetchOrder()
      }
    },
    async addTracking () {
      if (!this.shippingTrackingCode || !this.shippingTrackingCompany) {
        this.errors = true
      } else {
        var response = await FooshiApi.addTracking(this.$route.params.id, {shippingTrackingCode: this.shippingTrackingCode, shippingTrackingCompany: this.shippingTrackingCompany})
        if (response.success) {
          await this.fetchOrder()
        }
      }
    }
    // setStatus (status) {
    //   this.order.status = status
    // },
    // submitShipping (status) {
    //   alert(status)
    // },
    // sendProposal (status) {
    //   alert(status)
    // }
  },
  async mounted () {
    await this.fetchOrder()
    // await this.fetchStatus()
    this.ready = true
  },
  computed: {
    formattedOrder: function () {
      return {
        createdAt: Helpers.dateFormat(this.order.createdAt),
        expiresAt: Helpers.dateTimeFormat(this.order.expiresAt)
      }
    }
  },
  data () {
    return {
      order: {},
      // status: {},
      shippingTrackingCode: '',
      shippingTrackingCompany: '',
      errors: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/orders/OrderDetails.vue